import type { TFunction } from 'i18next';

export type TranslationFallbackOptions = Record<string, string | number | boolean | null | undefined>;

export const translateWithFallback = (
  t: TFunction,
  key: string,
  fallback: string,
  options: TranslationFallbackOptions = {},
): string => {
  const translated = t(key, { ...options, defaultValue: fallback });
  return typeof translated === 'string' && translated !== key ? translated : fallback;
};
